import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const BrandingContext = createContext(null);

const DEFAULT = {
  brand_name: "TaxPro Academy",
  logo_url: null,
  primary_color: "225 68% 40%",
  accent_color: "195 85% 55%",
  tagline: "",
  website: "",
  phone: "",
  email: "",
  facebook: "",
  address: "",
  tawk_property_id: "",
  tawk_widget_id: "",
};

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(DEFAULT);

  const applyCssVars = (b) => {
    const root = document.documentElement;
    if (b.primary_color) root.style.setProperty("--primary", b.primary_color);
    if (b.accent_color) root.style.setProperty("--accent", b.accent_color);
    if (b.brand_name) document.title = b.brand_name;
  };

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/branding");
      const b = r.data || DEFAULT;
      setBranding(b);
      applyCssVars(b);
    } catch (e) {
      applyCssVars(DEFAULT);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const update = async (payload) => {
    const r = await api.put("/branding", payload);
    setBranding(r.data);
    applyCssVars(r.data);
    return r.data;
  };

  return (
    <BrandingContext.Provider value={{ branding, update, refresh }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);
